// extracted by mini-css-extract-plugin
export default {"safe-payments-card":"SafePaymentsCard_safe-payments-card__3BcBu"};